import { FC } from "react";
import { Col, Form, Row } from "react-bootstrap";

interface Props {
  startDate: string;
  endDate: string;
  onStartDateChange: (value: string) => void;
  onEndDateChange: (value: string) => void;
}

const DashboardDateRangeFilter: FC<Props> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
}) => (
  <Row className="mb-3 justify-content-end">
    <Col md={3}>
      <Form.Label className="mb-1 fs--1">Du</Form.Label>
      <Form.Control
        type="date"
        value={startDate}
        onChange={(e) => onStartDateChange(e.target.value)}
      />
    </Col>
    <Col md={3}>
      <Form.Label className="mb-1 fs--1">Au</Form.Label>
      <Form.Control
        type="date"
        value={endDate}
        onChange={(e) => onEndDateChange(e.target.value)}
      />
    </Col>
  </Row>
);

export default DashboardDateRangeFilter;
